export default __webpack_public_path__ + "static/media/FHPPolicy.59d330c5.jpg";